export const categories = [
  { id: 1, name: 'Clothing', description: 'Latest fashion trends' },
  { id: 2, name: 'Electronics', description: 'Gadgets & devices' },
  { id: 3, name: 'Home & Living', description: 'Furniture & decor' },
  { id: 4, name: 'Health & Beauty', description: 'Skincare & wellness' },
];